import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import en from '@/services/i18n/locales/enNew'
import ru from '@/services/i18n/locales/ruNew'
import es from '@/services/i18n/locales/esNew'
import it from '@/services/i18n/locales/itNew'
import pt from '@/services/i18n/locales/ptNew'

void i18n.use(initReactI18next).init({
  debug: true,
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translation: en,
    },
    ru: {
      translation: ru,
    },
    es: {
      translation: es,
    },
    it: {
      translation: it,
    },
    pt: {
      translation: pt,
    },
  },
  interpolation: {
    escapeValue: false,
  },
})
